<template>
  <div class="flex-col flex-ac flex-c nodata">
    <img src="@/assets/images/icon/nodata.png" alt="" />
    <p>{{ txt }}</p>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    txt: { type: String, default: "没有相关数据" },
  },
  components: {},
  computed: {
    ...mapGetters([""]),
  },
  data() {
    return {};
  },
  watch: {},
  mounted() {},
  methods: {},
  destoryed() {},
};
</script>
<style lang="stylus" scoped></style>
  


// WEBPACK FOOTER //
// src/components/nodata.vue